// import { ControlReportModalComponent } from '../modals/control-report/control-report.component';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { IExternalData } from '../../commons';
import {
  AlertModalComponent,
  LoaderModalComponent,
  ConfirmationModalComponent,
  ConfirmModalComponent,
  CharityChecktModalComponent,
  ProcessExternalRequestModal,
  ApproveRejectModalComponent,
  LoginDetailComponent,
  CreditcardConfirmationModalComponent,
} from '../modals';
import * as fromRoot from 'src/app/state/app.selectors';
import * as lgeApp from 'src/app/state/app.actions';
import { PaymentConfigDetailsComponent } from '../modals/payment-config-detail/payment-config-detail.component';
import { OverrideUserDetailsComponent } from '../modals/override-user-details/overried-user-details.component';
import { EinOrgDetailsComponent } from '../modals/ein-org-details/ein-org-details.component';
import { ExternalAccessRequestComponent } from '../modals/external-access-details/external-access-details.component';
import { ComposeEmailModalComponent } from '../modals/compose-email/compose-email.component';
import { EmailTemplateModalComponent } from '../modals/email-template/email-template.component';
import { ToastrService } from 'ngx-toastr';
import { AccDistDetailsComponent } from '../components/acc-dist-details/acc-dist-details.component';
import { ProjectTaskDetailsComponent } from '../components/project-task-details/project-task-details.component';

@Injectable()
export class AngularMaterialService {
  public alert!: MatDialogRef<any>;
  public loader!: MatDialogRef<any>;
  public confirmation!: MatDialogRef<any>;
  public override!: MatDialogRef<any>;
  public einOrgDetail!: MatDialogRef<any>;
  public confirm!: MatDialogRef<any>;
  public emailTemplate!: MatDialogRef<any>;
  public composeEmail!: MatDialogRef<any>;
  public approveReject!: MatDialogRef<any>;
  public accDist!: MatDialogRef<any>;
  public projectTask!: MatDialogRef<any>;
  public validateFormCC!: MatDialogRef<any>;
  public controlReport!: MatDialogRef<any>;
  public charityCheck!: MatDialogRef<any>;
  public creditCardConfirmation!: MatDialogRef<any>;
  public externalAccessData!: MatDialogRef<any>;
  public externalAccessDataEdit!: MatDialogRef<any>;
  public openRequest!: MatDialogRef<any>;
  public validateFormExt!: MatDialogRef<any>;
  public paymentConfig!: MatDialogRef<any>;
  public login!: MatDialogRef<any>;
  public processExternalRequest!: MatDialogRef<any>;
  private alertModalClass = 'warn-modal';

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<fromRoot.AppState>
  ) {}

  public showAlert(title: string, message: string, redirect?: boolean) {
    switch (true) {
      case /Error/.test(title):
      case /Error/.test(message):
        this.alertModalClass = 'error-modal';
        break;
      case /Success/.test(title):
      case /Success/.test(message):
        this.alertModalClass = 'success-modal';
        break;
      default:
        this.alertModalClass = 'warn-modal';
        break;
    }
    this.alert = this.dialog.open(AlertModalComponent, {
      minWidth: '25%',
      maxWidth: '50%',
      minHeight: '25%',
      disableClose: true,
      panelClass: this.alertModalClass,
      data: { title: title, message: message },
    });

    this.alert.afterClosed().subscribe(() => {
      if (redirect) {
        this.router.navigate([`login`]);
      }
      this.closeDialog();
    });
  }
  public showLoader(message: string) {
    this.store.dispatch(new lgeApp.UpdateSplashScreenStatus(true, message));
  }

  public showConfirmation(
    message: string,
    formName: string,
    requestName: string,
    length: number
  ) {
    this.confirmation = this.dialog.open(ConfirmationModalComponent, {
      width: '400px',
      disableClose: false,
      panelClass: 'confirmation-modal',
      data: {
        formName: formName,
        requestName: requestName,
        length: length,
        message: message,
      },
    });
  }

  public showConfirm(title: string, message: string) {
    this.confirm = this.dialog.open(ConfirmModalComponent, {
      width: '360px',
      disableClose: false,
      panelClass: 'confirm-modal',
      data: { title: title, message: message },
    });
  }

  public showCharityCheck(title: string, message: string) {
    this.charityCheck = this.dialog.open(CharityChecktModalComponent, {
      width: '360px',
      disableClose: false,
      panelClass: 'charity-check-modal',
      data: { title: title, message: message },
    });
  }
  public showLogin(isTryAgain: boolean) {
    this.login = this.dialog.open(LoginDetailComponent, {
      width: '360px',
      disableClose: true,
      data: { isTryAgain },
    });
  }

  public closeDialog(): Promise<any> {
    this.store.dispatch(new lgeApp.UpdateSplashScreenStatus(false));
    return new Promise<void>((resolve, reject) => {
      this.dialog.closeAll();
      resolve();
    });
  }

  public showProcessExternalRequest(
    title: string,
    message: string,
    confirmationData: any,
    info: any
  ) {
    this.processExternalRequest = this.dialog.open(
      ProcessExternalRequestModal,
      {
        height: '465px',
        width: '55vw',
        disableClose: true,
        data: { title, message, confirmationData, info },
      }
    );
  }
  public showPaymentConfigDetails(
    title: string,
    configType: string,
    configData: any
  ) {
    this.paymentConfig = this.dialog.open(PaymentConfigDetailsComponent, {
      height: configType === 'form' ? '560px' : '320px',
      width: '800px',
      disableClose: true,
      data: { title: title, configType, configData },
    });
  }

  public showOverrideDetails(
    title: string,
    message: string,
    userData: any,
    MGList: any,
    SM_ECList: any,
    ECList: any,
    isEditMode: boolean
  ) {
    this.override = this.dialog.open(OverrideUserDetailsComponent, {
      height: '695px',
      width: '650px',
      disableClose: false,
      data: {
        title: title,
        message: message,
        userData,
        MGList,
        SM_ECList,
        ECList,
        isEditMode,
      },
    });
  }
  public showCreditCardConfirmation(
    title: string,
    message: string,
    confirmationData: any
  ) {
    this.creditCardConfirmation = this.dialog.open(
      CreditcardConfirmationModalComponent,
      {
        height: '428px',
        width: '550px',
        disableClose: true,
        data: { title: title, message: message, confirmationData },
      }
    );
  }
  public showApproveReject(title: string, message: string) {
    this.approveReject = this.dialog.open(ApproveRejectModalComponent, {
      panelClass: 'full-width-dialog',
      width: '370px',
      disableClose: false,
      data: { title: title, message: message },
    });
  }

  public showEinOrgDetail(
    title: string,
    message: string,
    einOrgInfo: any,
    einOrgDetail: any,
    isEditMode: boolean
  ) {
    this.einOrgDetail = this.dialog.open(EinOrgDetailsComponent, {
      minHeight: '50vh',
      maxHeight: '100vh',
      width: '800px',
      disableClose: false,
      data: {
        title: title,
        message: message,
        einOrgInfo,
        einOrgDetail,
        isEditMode,
      },
    });
  }

  public showAccessRequestDetails(
    title: string,
    externalData: IExternalData,
    isApproving: boolean
  ) {
    this.externalAccessData = this.dialog.open(ExternalAccessRequestComponent, {
      maxHeight: '650px',
      width: '550px',
      disableClose: false,
      data: { title: title, externalData, isApproving },
    });
  }
  public showComposeEmail(
    title: string,
    message: string,
    isNotSystemTemplateList: any,
    toAddList: any
  ) {
    this.composeEmail = this.dialog.open(ComposeEmailModalComponent, {
      maxHeight: '100vh',
      width: '735px',
      disableClose: false,
      data: {
        title: title,
        message: message,
        isNotSystemTemplateList,
        toAddList,
        ccList: toAddList,
      },
    });
  }

  public showComposeAwardDeclineEmail(
    title: string,
    message: string,
    isNotSystemTemplateList: any,
    toAddList: any,
    ccList: any
  ) {
    this.composeEmail = this.dialog.open(ComposeEmailModalComponent, {
      maxHeight: '100vh',
      width: '735px',
      disableClose: false,
      data: {
        title: title,
        message: message,
        isNotSystemTemplateList,
        toAddList,
        ccList,
      },
    });
  }

  public showEmailTemplate(
    title: string,
    message: string,
    emailTemplateData: any,
    isEditMode: boolean,
    isReadOnly: boolean,
    isReadOnlyList: any
  ) {
    this.emailTemplate = this.dialog.open(EmailTemplateModalComponent, {
      maxHeight: '100vh',
      width: '735px',
      disableClose: false,
      data: {
        title: title,
        message: message,
        emailTemplateData,
        isEditMode,
        isReadOnly,
        isReadOnlyList,
      },
    });
  }

  public showAccDistDetails(title: string, message: string, accDistData: any) {
    this.accDist = this.dialog.open(AccDistDetailsComponent, {
      height: '600px',
      width: '650px',
      disableClose: false,
      data: { title: title, message: message, accDistData },
    });
  }
  public showProjectTaskDetails(
    title: string,
    message: string,
    projectTaskData: any
  ) {
    this.projectTask = this.dialog.open(ProjectTaskDetailsComponent, {
      height: '600px',
      width: '800px',
      disableClose: false,
      data: { title: title, message: message, projectTaskData },
    });
  }
}
